import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import { useAlertStore } from "../../hooks/store";
import Box from "@mui/material/Box";

export default function AlertProvider({ children }) {
  const alertStore = useAlertStore();
  const { open, text, type, setAlert, closeAlert } = alertStore;

  return (
    <>
      {children}{" "}
      <Box
        sx={{
          position: "absolute",
          right: "0",
          bottom: 0,
          margin: " 24px 30px",
        }}>
        <Collapse in={open}>
          <Alert severity={type} variant="filled" onClose={closeAlert}>
            {text}
          </Alert>
        </Collapse>
      </Box>
    </>
  );
}
